import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { Button } from '../../components/Button'
import { Space } from '../../components/Space'
import { Text } from '../../components/Text'
import { hexToRgb } from '../../components/theme'
import { getCmsLoginUrl } from '../../redux/config'
import { formatUrl } from '../../utils/routes'

export const Container = styled.div<{ loggedIn: boolean; minHeight?: string }>`
  position: relative;
  width: 100%;
  border-radius: 4px;
  padding: 24px 0;
  ${({ minHeight }) =>
    minHeight &&
    `
    min-height: ${minHeight};
  `}
`

export const Overlay = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 4px;
  background-color: ${({ theme }) => `rgba(${hexToRgb(theme.colors.primary)}, 0.2)`};

  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const OpacityContainer = styled.div<{ opacity?: string }>`
  width: 100%;
  ${({ opacity }) => opacity && `opacity: ${opacity};`}
`

type Props = {
  children: React.ReactNode | React.ReactNodeArray
  visible: boolean
  minHeight?: string
}

export const LoginOverlay = ({ children, visible, minHeight }: Props) => {
  const { t } = useTranslation('core')
  const cmsLoginUrl = useSelector(getCmsLoginUrl)

  return (
    <Container loggedIn={visible} minHeight={minHeight}>
      <OpacityContainer opacity={visible ? '0.06' : undefined}>{children}</OpacityContainer>
      {visible && (
        <Overlay>
          <Text block pb="30px" color="darkGray" fontFamily="'Lato', sans-serif">
            {t('RegisterToUnlock')}
          </Text>
          <Space space={2}>
            {/* <Button variant="primary">{t('Register')}</Button> */}
            <a
              href={formatUrl(encodeURI(window.location.origin), cmsLoginUrl ? encodeURI(cmsLoginUrl) : undefined, {
                returnUrl: window.location.href
              })}
            >
              <Button variant="primary">{t('Login')}</Button>
            </a>
          </Space>
        </Overlay>
      )}
    </Container>
  )
}
